import styled from 'styled-components'

export const StyledDatePickerContainer = styled.div`
	opacity: ${({ disabled }) => disabled ? 0.5 : 1};
`
